module.exports = __webpack_public_path__ + "static/profile-21f60383c247b1047482e28c4970f5a9.png";